export default __webpack_public_path__ + "static/media/3-pieces-middle-mantle.c0db38d5.svg";